import { Outlet, useParams, Navigate } from "react-router-dom";
import { useEffect, useContext } from "react";
import { LangContext } from "../../context/LangContext";

const allowedLangs = ["fr", "en"];

function LayoutWithLang() {
    const { lang } = useParams();
    const { toggleLanguage } = useContext(LangContext);

    const isValid = allowedLangs.includes(lang);

    useEffect(() => {
        if (isValid) toggleLanguage(lang);
    }, [lang, isValid, toggleLanguage]);

    if (!isValid) return <Navigate to="/fr" replace />;

    return <Outlet />;
}

export default LayoutWithLang;